import { atom } from 'jotai'

export const fullscreenAtom = atom(false)

// Create an atom with a reference object which is possibly null.
export const videoElementAtom = atom<HTMLVideoElement | null>(null)

export const frameRefAtom = atom<HTMLDivElement | null>(null)

export const videoWrapperElementAtom = atom<HTMLDivElement | null>(null)

export const controlsVisibilityLockAtom = atom(false)

const controlsVisibilityAtom = atom<boolean>(false)
export const rControlsVisibilityAtom = atom<boolean>((get) => get(controlsVisibilityAtom))
export const wControlsVisibilityAtom = atom(null, (get, set, update) => {
  const isModificationAllowed = !get(controlsVisibilityLockAtom)
  if (isModificationAllowed) {
    set(controlsVisibilityAtom, update as boolean)
  }
})

export const ownsNFTAtom = atom(false)
export const videoSourceAtom = atom<
  | {
      address: string | undefined
      src: string | undefined
    }
  | undefined
>(undefined)

export const skipForwardsSecondsAtom = atom(0)
export const skipBackwardsSecondsAtom = atom(0)

// =============================================================================
// Mobile Specific Atoms
// =============================================================================

const visibilityTimerAtom = atom<NodeJS.Timeout | null>(null)

/**
 *  Read-write atom that stores timeout for the controls visibility.
 */
export const rVisibilityTimerIdAtom = atom<NodeJS.Timeout | null>((get) => get(visibilityTimerAtom))

export const wVisibilityTimerIdAtom = atom(null, (get, set, update) => {
  const timerId = get(visibilityTimerAtom)
  if (update == 'cancel') {
    // Stop the timer if it's running.
    if (timerId) {
      clearTimeout(timerId)
    }
    set(visibilityTimerAtom, null)
  } else if (update == 'start') {
    // When there is already a timer running, don't restart one.
    if (!timerId) {
      set(
        visibilityTimerAtom,
        setTimeout(() => {
          set(wControlsVisibilityAtom, false)
          set(visibilityTimerAtom, null)
        }, 3000)
      )
    }
  } else if (update == 'restart') {
    // Restart the timer, no matter if there is already one running.
    if (timerId) {
      clearTimeout(timerId)
    }
    set(
      visibilityTimerAtom,
      setTimeout(() => {
        set(wControlsVisibilityAtom, false)
        set(visibilityTimerAtom, null)
      }, 3000)
    )
  }
})

export const timelineExcludedVisibilityAtom = atom(true)

/** Atom which stores whether the seek mode is enabled.
 *  The seek mode deactivates the time updates for the timeline, so the user can seek around.
 */
export const seekModeAtom = atom(false)

export const fadeAtom = atom(false)

/**
 * Read-write atom that activates and deactivates the space bar.
 */
export const spacebarListenerActiveAtom = atom(true)
